<template>
  <div class="menu">
    <div class="menu-profile">
      <router-link to="/app-selector">
        <img :src="appLogoSvg" class="img-fluid"/>
      </router-link>
    </div> 
    <div
      id="appSidebarProfileMenu"
      class="collapse"
      v-bind:class="{
        'd-block':
          this.stat == 'expand' && !this.appOptions.pageSidebarMinified,
        'd-none': this.stat == 'collapse',
      }"
    >
      <div class="menu-item">
        <router-link to="/profile" class="menu-link pt-5px">
          <div class="menu-icon"><i class="fa fa-user"></i></div>
          <div class="menu-text">Profilom</div>
        </router-link>
      </div>
      <div class="menu-divider m-0"></div>
    </div>
  </div>
</template>

<script>
import AppOptions from "../../config/AppOptions.vue";

export default {
  name: "SidebarNavProfile",
  data() {
    return {
      stat: "",
      appOptions: AppOptions      
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    appModes() {
      return this.$store.state.appModes;
    },
    mode() {
      return this.$store.state.mode;
    },
    appLogoSvg(){
      
      const selectedMode = this.appModes.find(item => item.mode === this.mode);
      
      // If mode is found, dynamically load the image from the assets folder
      if (selectedMode) {
        return require(`@/assets/img/${selectedMode.logo}`);
      }

      return require(`@/assets/img/${selectedMode.logo}`);
    }
  },
  methods: {
  },
};
</script>
